import { createContext, useContext, useMemo, useState } from 'react'

import { ThemeProvider } from 'styled-components'

import { AntOverrides } from 'src/styles/AntOverrides'
import { buildPassTheme } from 'src/styles/theme'

import { StylingSettingsUiQuery } from 'types/api.graphql'
import { BuildPassTheme } from 'types/BuildPassTheme'

type Theme = StylingSettingsUiQuery['stylingSettings']

interface ThemeContextType {
  setThemeColours: (theme: Theme) => void
}

const ThemeContext = createContext<ThemeContextType>({
  setThemeColours: () => {},
})

type Props = {
  children?: React.ReactNode
}

export const BuildPassThemeProvider: React.FC<Props> = ({ children }) => {
  const [themeColours, setThemeColours] = useState<Theme>()

  const theme = useMemo<BuildPassTheme>(() => {
    return {
      ...buildPassTheme,
      colour: {
        ...buildPassTheme.colour,
        theme: {
          primaryColour:
            themeColours?.primaryColour ?? buildPassTheme.colour.primary._200,
          buttonTextColour:
            themeColours?.buttonTextColour ??
            buildPassTheme.colour.secondary.base,
          primaryTextColour:
            themeColours?.primaryTextColour ??
            buildPassTheme.colour.primary._700,
        },
      },
    }
  }, [themeColours])

  return (
    <ThemeContext.Provider value={{ setThemeColours }}>
      <ThemeProvider theme={theme}>
        <AntOverrides />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}

export const useThemeContext = () => useContext(ThemeContext)
